import { Component, OnInit, Inject, Renderer2, OnDestroy } from '@angular/core';
import { Router } from "@angular/router";
import { CommonService } from '@services/app.common.service';
import { AlertService } from '../../_services/alert.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-homelayout',
    templateUrl: './app-layout.component.html',
    styleUrls: ['./app-layout.component.css'],
    standalone: false
})
export class AppLayoutComponent implements OnInit,OnDestroy {
  private subscription = {} as Subscription;
  public className = 'has-footer-menu';
  constructor(public alertService: AlertService) { }

  ngOnInit() {
     
    this.subscription = this.alertService.getMessage()?.subscribe(message => {
      if (message) {
        if (message.text == 'dark') {
          this.className = 'app--dark';
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription?.unsubscribe();
  }
  onScrollDown() {
    this.alertService?.sendMessage('scrollDown');
  }

}
